import memoize from 'lodash-es/memoize';

/**
 * Generate modified version of react-virtualized.accessibilityOverscanIndicesGetter
 * Because we are using server side rendering - we need to render all items for the first page.
 * On the client when user loads additional data - we can switch to more performing items slice.
 *
 * @param numberOfItemsOnFirstPage - number of items for the first page
 */
export const overscanIndicesGetterFactory = (numberOfItemsOnFirstPage) => ({ cellCount, overscanCellsCount, scrollDirection, startIndex, stopIndex }) => {
    let overscanStartIndex;
    let overscanStopIndex;

    overscanCellsCount = Math.max(1, overscanCellsCount);

    /* NOTE: Always render all items when cellCount is less than first page */
    if (cellCount <= numberOfItemsOnFirstPage + 1 /* items per page + 1 loading placeholder */) {
        overscanStartIndex = 0;
        overscanStopIndex = cellCount - 1;
    } else {
        switch (scrollDirection) {
            case -1:
                overscanStartIndex = startIndex - 1;
                overscanStopIndex = stopIndex + overscanCellsCount;
                break;
            default: // case 1:
                overscanStartIndex = startIndex - overscanCellsCount;
                overscanStopIndex = stopIndex + 1;
                break;
        }
    }

    return {
        overscanStartIndex: Math.max(0, overscanStartIndex),
        overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex),
    };
};

// This should prevent some unecessary react updates :)
export const memoizedOverscanIndicesGetterFactory = memoize(overscanIndicesGetterFactory);
